import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import { auth } from "../../firebase";
import { Link } from "react-router-dom";
import UserGroupSearch from "../SearchFunctionality";

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);


  useEffect(() => {
    // Check for Bootstrap availability
    if (!window.bootstrap) {
      console.error("Bootstrap JS not loaded. Ensure the CDN is included in index.html.");
    }

    // Firebase Auth listener
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        // Fetch user data from database to check USERISADMIN
        try {
          const db = getDatabase();
          const userRef = ref(db, `USERS/${currentUser.uid}`);
          const snapshot = await get(userRef);
          
          if (snapshot.exists()) {
            const userData = snapshot.val();
            setIsAdmin(userData.USERISADMIN === "Y");
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

 const [theme, setTheme] = useState("light");

  // Sync React state with <html data-theme> on first render
  useEffect(() => {
    const currentTheme =
      document.documentElement.dataset.theme || "light";
    setTheme(currentTheme);
  }, []);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";

    // Apply theme
    document.documentElement.dataset.theme = next;
    localStorage.setItem("theme", next);

    // Update button label
    setTheme(next);
  };

  const handleSelectUser = (user) => {
    // console.log("Selected user:", user);
    // TODO: Add your logic here - navigate to user profile, open chat, etc.
  };

  const handleSelectGroup = (group) => {
    // console.log("Selected group:", group);
    // TODO: Add your logic here - navigate to group page, etc.
  };

  return (
    <div className="">
      <nav className="navbar navbar-expand-lg ">
        <div className="container-sm">
          {/* <Link className="h3 mb-0 header-text-logo me-3" to="/" >Attend<span className="header-text-logo-span">iau.</span></Link> */}
          <Link className="h3 mb-1 header-text-logo me-3" to="/" ><img src="/assets/img/attendiau.png" alt="Attendiau."  loading="lazy" id="navlogo"/></Link>

              {/* <Link
                  className="nav-link desktop-view-button"
                  to="/"
                >
                  Categories
                </Link> */}
                <div className="dropdown desktop-view-button">
                  <button 
                    className="btn btn-link nav-link "
                    type="button"
                    id="categoriesDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Categories 
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="categoriesDropdown">
                    <li>
                      <Link className="dropdown-item mb-1" to="/Automotive">
                      Automotive
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item mb-1" to="/Sports">
                        Sports
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item mb-1" to="/Music">
                       Music
                      </Link>
                    </li>
                  </ul>
                </div>
                
        {/* <Link className="nav-link desktop-view-button" to="/Groups" >Groups</Link> */}
            <div className="desktop-view-button"> 
         <UserGroupSearch onSelectUser={handleSelectUser} onSelectGroup={handleSelectGroup}  />
         </div>

           {/* <Link className="nav-link desktop-view-button" to="/News" >News</Link>
         <Link className="nav-link desktop-view-button" to="/Support" >Support</Link> */}


        <button className="mobile-icon mobile-view-button pb-0 mb-0" type="button" data-bs-toggle="offcanvas" data-bs-scroll="true"  data-bs-target="#offcanvasTop" aria-controls="offcanvasTop"><i className="mwlg2 bi bi-list"></i></button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-lg-center">


          <button id="theme-toggle" aria-label="Toggle theme" onClick={toggleTheme}> {theme === "dark" ? <><i className="bi bi-sun mwlg2"></i> </> : <><i className="bi bi-moon-stars mwlg"></i> </>} </button>
              

        {user ? (   
          <>
            {user && (
              <li className="nav-item">
                    <div className="dropdown ">
                      <button type="button" data-bs-toggle="dropdown" className="lalalal pb-0 mb-0"><i className="bi bi-person"></i></button>
                      <ul className="dropdown-menu mt-2">
                          <li>
                            <Link className="dropdown-item" to="/YourEvents">
                              Manage Events
                            </Link>
                          </li>
                          <li>
                            <Link className="dropdown-item" to="/Attending">
                              Attending
                            </Link>
                          </li>
                          <li>
                            <Link className="dropdown-item" to="/Settings">
                              Settings
                            </Link>
                          </li>
                          {isAdmin && (
                          <li>
                            <Link className="dropdown-item" to="/AdminReports">
                              Secret Admin
                            </Link>
                          </li>
                          )}
                        <li><hr className="dropdown-divider" /></li>
                        <li><button className="dropdown-item" onClick={() => auth.signOut()}> <i className="bi bi-box-arrow-right me-2 text-red"></i> Sign out</button></li>
                      </ul>
                    </div>
              </li>
            )}

            {user && (
            <li className="nav-item ms-3">
              <Link className="btn btn-primary" to="/CreateEvent" > Create Event </Link>
            </li>
            )}
        </>
        ) : (

            <li className="nav-item ms-3">
                <Link to="/Login"> <button className="btn btn-primary " aria-label="Close">Login</button> </Link> 
            </li>
        )}
            </ul>
          </div>
        </div>
      </nav>



          <div className="offcanvas offcanvas-top" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel" data-bs-scroll="true">
            <div className="offcanvas-header">
              <button type="button" className="btn-close closee text-reset text-primary" data-bs-dismiss="offcanvas" aria-label="Close"> <i className="bi bi-x-lg"></i> </button>
            </div>
            <div className="offcanvas-body">
              {/* mobile sidenav section Links */}
              {/* Navigation Links */}
              <nav className="d-flex flex-column gap-2 mb-4">

              {user ? (
                <nav className="d-flex flex-column gap-2">
                  <Link className="btn btn-primary w-100 mb-2" to="/CreateEvent">
                    <i className="bi bi-plus-circle me-2"></i> Create Event
                  </Link>
                </nav>
              ) : (
                <>
                </>
              )}

                <Link className="nav-link h5 mb-0" to="/">
                  Home
                </Link>
                

              {user ? (
                <> 
                  <Link className="nav-link h6 mb-0" to="/YourEvents">
                   Manage Events
                  </Link>
                  <Link className="nav-link h6 mb-0" to="/Attending">
                  Attending
                  </Link>
                  <Link className="nav-link h6 mb-0" to="/Settings">
                  Settings
                  </Link>
                </>
              ) : (
                <> 
                </>
              )}

                 {/* Categories Dropdown */}
                <div className="dropdown nav-link h5 mb-0 nav-phone-dropdown">
                  <button 
                    className="btn btn-link nav-link h5 mb-0 text-start p-0 d-flex align-items-center gap-2"
                    onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                  >
                    Categories <i className="bi bi-plus"></i>
                  </button>
                  {mobileDropdownOpen && (
                    <>
                      <Link className="dropdown-item h6 my-3 ms-2 p-2" to="/Automotive">
                      Automotive
                      </Link>
                      <Link className="dropdown-item h6 mb-0 ms-2 p-2" to="/Sports">
                      Sports
                      </Link>
                      <Link className="dropdown-item h6 my-3 ms-2 p-2" to="/Music">
                      Music
                      </Link>
                    </>
                  )}
                </div>

                <Link className="nav-link  h5 mb-0" to="/Groups" >Groups</Link>
                <Link className="nav-link h5 mb-0" to="/news">
                  News
                </Link>
                <Link className="nav-link h5 mb-0" to="/Support">
                  Support
                </Link>
                {isAdmin && (
                  <Link className="nav-link h5 mb-0" to="/AdminReports">
                    Secret Admin
                  </Link>
                )}
              </nav>

              <button 
                id="theme-toggle" 
                aria-label="Toggle theme" 
                onClick={toggleTheme}
                className="btn btn-outline-secondary w-100 mb-3"
              >
                 {theme === "dark" ? <><i className='bi bi-sun mwlg2 me-2'></i> Light Mode </> : <><i className="bi bi-moon-stars mwlg me-2"></i> Dark Mode</>}
             
              </button>
              
              {user ? (
                <nav className="d-flex flex-column gap-2">

                  <hr className="my-2" />
                  <button 
                    className="btn btn-danger w-100"
                    onClick={() => auth.signOut()}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i> Sign Out
                  </button>
                </nav>
              ) : (
                <>
                <div className="d-flex flex-column gap-2">
                   <hr className="my-2" />
                  <Link to="/Login" className="btn btn-primary w-100">
                    <i className="bi bi-box-arrow-in-right me-2"></i> Login
                  </Link>
                </div> 
                </>
              )}



            </div>
          </div>


    </div>
  );
};

export default Navbar;

